import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import routes from '~pages'
import pinia from '@/stores'
import App from './App.vue'
import './styles/tailwind.css'

// 라우터 설정
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...routes,
    // 404 페이지 리다이렉트
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
})

// 네비게이션 가드
router.beforeEach((to, from, next) => {
  // 페이지 제목 설정
  if (to.meta.title) {
    document.title = `${to.meta.title} - ${import.meta.env.VITE_APP_TITLE}`
  } else {
    document.title = import.meta.env.VITE_APP_TITLE || 'DiSC 직무적성 검사'
  }
  
  next()
})

// Vue 앱 생성 및 설정
const app = createApp(App)

// 플러그인 등록
app.use(pinia)
app.use(router)

// 전역 속성 설정
app.config.globalProperties.$env = import.meta.env

// 앱 마운트
app.mount('#app')

// 개발 환경에서 라우터 정보 로깅
if (import.meta.env.DEV) {
  console.log('📋 Available Routes:', routes.map(route => ({
    path: route.path,
    name: route.name,
    component: route.component?.name || 'Anonymous'
  })))
}
